import React from "react";
import { Button, Menu, Dropdown, Modal } from "antd";

import Filters from "./Filters";
import Grid from "./Grid";
import NewAnalysis from "./NewAnalysis/index";

const menu = (
  <Menu>
    <Menu.Item key="0">
      <a href="/">1st menu item</a>
    </Menu.Item>
    <Menu.Item key="1">
      <a href="/">2nd menu item</a>
    </Menu.Item>
    <Menu.Item key="2">3rd menu item</Menu.Item>
  </Menu>
);

class Analysis extends React.Component {
  constructor() {
    super();
    this.state = {
      visibleModal: false
    };
  }

  showModal = () => {
    this.setState({
      visibleModal: true
    });
  };

  handleOk = () => {
    this.setState({ visibleModal: true });
  };

  handleCancel = () => {
    this.setState({ visibleModal: false });
  };

  render() {
    const menuAnalysis = (
      <Menu>
        <Menu.Item key="0" onClick={this.showModal}>
          Create new
        </Menu.Item>
        <Menu.Item key="1">Use Previous Settings</Menu.Item>
      </Menu>
    );

    const { visibleModal } = this.state;

    return (
      <div className="layout">
        <div className="layout__head">
          <div className="layout__title">Analysis Name</div>
          <Dropdown
            className="layout__actions"
            overlay={menuAnalysis}
            trigger={["click"]}
          >
            <Button type="primary">New Analysis</Button>
          </Dropdown>
          <Modal
            width={"100%"}
            style={{ maxWidth: 1312 }}
            zIndex={1040}
            visible={visibleModal}
            centered={true}
            title={false}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
            footer={false}
          >
            <NewAnalysis onCancel={this.handleCancel} />
          </Modal>
          <div className="layout__right">
            <Dropdown
              className="layout__dropdown"
              overlay={menu}
              trigger={["click"]}
              placement="bottomRight"
            >
              <Button className="ant-btn-dropdown">
                <span>Actions</span>
                <img src="/img/arrow-down.svg" alt="" />
              </Button>
            </Dropdown>
          </div>
        </div>
        <div className="layout__body">
          <div className="layout__sidebar">
            <Filters />
          </div>
          <div className="layout__container">
            <Grid />
          </div>
        </div>
      </div>
    );
  }
}

export default Analysis;
